import { def } from '@gaspardesk/utils';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import React, { useMemo } from 'react';

import { ScrollableTabPanel } from '../../components/interactive/ScrollableTabPanels';
import { StrapiApiPlugin } from '../../lib/integrations/strapi/types';

// Dynamically import with SSR disabled
const ScrollableTabPanels = dynamic(() => import('../../components/interactive/ScrollableTabPanels'), { ssr: false });

type AutomationProtocolsWidgetProps = { plugins: StrapiApiPlugin[] };

type IntegrationsPanelData = { title: string; entries: Array<{ label: string; content: string }>; logoUrl?: string };

const AutomationProtocolsWidget: React.FC<AutomationProtocolsWidgetProps> = React.memo((props) => {
  const { plugins } = props;
  const renderPanel = (data: IntegrationsPanelData) => {
    const { title, entries, logoUrl } = data;
    return (
      <div>
        {def(logoUrl) && <Image src={logoUrl} width={150} height={72} alt={title} className="mb-2" />}
        <h3 className="leading-none mt-4">Integration Capabilities </h3>
        <ul className="flex flex-col gap-4 my-4">
          {entries.map((record, index) => (
            <li key={`plugin-protocol-${index}`} className="not-last:border-b-2 border-gray flex flex-col gap-2 pb-2">
              <p className="text-2xl">{record.label}</p>
              <p>{record.content}</p>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const panels: ScrollableTabPanel<IntegrationsPanelData>[] = useMemo(() => {
    return plugins.map((plugin) => {
      const { name, protocols, logoUrl } = plugin.attributes;
      const entries = (protocols.data || []).map((protocol) => ({
        label: protocol.attributes.name,
        content: protocol.attributes.description,
      }));
      return { tabLabel: name, data: { title: name, entries, logoUrl } };
    });
  }, [plugins]);
  return <ScrollableTabPanels panels={panels} renderPanel={renderPanel} />;
});
AutomationProtocolsWidget.displayName = 'AutomationProtocolsWidget';
export default AutomationProtocolsWidget;
